import { render, staticRenderFns } from "./landing-header.vue?vue&type=template&id=d56c8b22&scoped=true&"
import script from "./landing-header.vue?vue&type=script&lang=js&"
export * from "./landing-header.vue?vue&type=script&lang=js&"
import style0 from "./landing-header.vue?vue&type=style&index=0&id=d56c8b22&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56c8b22",
  null
  
)

export default component.exports